<script>
	import Authentication from './components/Authentication.svelte';
	import Home from './components/Home.svelte';
	import Debug from './components/debug';

	$: urlpath = window.location.pathname;
</script>

<style>
	section {
		margin: 12px;
	}
</style>

<svelte:head>
	<!-- See for updating title reactively: https://svelte.dev/docs -->
	<title>Concord - Let's Play</title>
</svelte:head>

<section>
	{#if urlpath.startsWith('/auth')}
		<Authentication/>
	{:else if urlpath.startsWith('/')}
		<Home/>
	{/if}
	<Debug.Path/>
</section>

